import { inject } from '@angular/core';
import { WorkflowService } from '../services/workflow.service';

export function isPolicyAcknowledgeGuard() {
    const isPolicyAcknowledged = inject(WorkflowService).getWguPolicyAcknowledge();
    // console.log("Policy Acknowledged: " + isPolicyAcknowledged)
    return isPolicyAcknowledged
}